export default __webpack_public_path__ + "static/media/grant.d0ca8cde.mp3";